import React, { useRef, useState } from 'react';
import image1 from '../../assets/hp1.png';
import image2 from '../../assets/hp2.png';
import divider from '../../assets/divider-img.png';
import { BsArrowRightShort, BsArrowLeftShort } from 'react-icons/bs';

const HomeProjects = () => {
  const slides = [
    {
      image: image1,
      title: 'Project Name',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
    },
    {
      image: image2,
      title: 'Project Name',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
    },
    {
      image: image1,
      title: 'Project Name',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
    },
    {
      image: image2,
      title: 'Project Name',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
    },
  ];

  const [startIndex, setStartIndex] = useState(0);

  const handleNext = () => {
    const nextIndex = startIndex + 1;
    if (nextIndex + 1 <= slides.length - 1) {
      setStartIndex(nextIndex);
    }
  };

  const handlePrevious = () => {
    const previousIndex = startIndex - 1;
    if (previousIndex >= 0) {
      setStartIndex(previousIndex);
    }
  };

  const windowWidth = useRef(window.innerWidth);

  return (
    <div className="home-projects">
      <div className="container">
        <div className="home-projects-wrapper">
          {windowWidth.current <= 768 ? (
            <div className="project-slider">
              {slides.slice(startIndex, startIndex + 1).map((slide, index) => (
                <div>
                  <div key={index} className="slide">
                    <div className="slide-content">
                      <img
                        src={slide.image}
                        alt={`Slide ${startIndex + index}`}
                      />
                      <div className="slide-info">
                        <h3>{slide.title}</h3>
                        <p>{slide.description}</p>
                      </div>
                    </div>
                  </div>
                  <div className="next-prev next-perv-mob">
                    <div className="prev-next-indi" onClick={handlePrevious}>
                      <BsArrowLeftShort />
                      <p>PREV</p>
                    </div>
                    /
                    <div className="prev-next-indi" onClick={handleNext}>
                      <p>NEXT</p>
                      <BsArrowRightShort />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="project-slider">
              {slides.slice(startIndex, startIndex + 2).map((slide, index) => (
                <div key={index} className="slide">
                  <div className="slide-content">
                    <img
                      src={slide.image}
                      alt={`Slide ${startIndex + index}`}
                    />
                    <div className="slide-info">
                      <h3>{slide.title}</h3>
                      <p>{slide.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="project-content-right">
            <h2>Delivered Projects</h2>

            <div className="divider">
              <img src={divider} alt="divider" />
            </div>
            <p>
              Quantome is delivering excellence in every project! We take pride
              in our track record of delivering exceptional results to our
              clients.
            </p>
            <button className="view-all-btn">
              View All Projects <BsArrowRightShort />
            </button>
            <div className="next-prev to-display-586">
              <div className="prev-next-indi" onClick={handlePrevious}>
                <BsArrowLeftShort />
                <p>PREV</p>
              </div>
              /
              <div className="prev-next-indi" onClick={handleNext}>
                <p>NEXT</p>
                <BsArrowRightShort />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeProjects;
